import * as React from 'react';
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';
import AnchorV2 from 'components/AnchorV2';

export interface LinkProps extends MuiLinkProps {
  component?: React.ElementType;
}

/**
 * Link should be used for all text link navigation. It uses the Anchor component internally, which will generate either a react-router link or a regular link.
 *
 * ```js
 * import { Link } from 'ui';
 * ```
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ component = AnchorV2, color = 'primary', ...rest }, ref) => {
    return <MuiLink component={component} color={color} ref={ref} {...rest} />;
  }
);

export default Link;
